import React from 'react'
import logo from '../assets/logo.png'
import { Typography, Stack } from '@mui/material';

const Header = () => {
    return (
        <Stack direction='row' sx={{ alignItems: 'center' }}>
            <img src={logo} className="logo" alt="logo" />
            <Typography variant='h3' sx={{ ml: 20 }}>Software Download</Typography>
        </Stack>
    )
}

export default Header